// extracted by mini-css-extract-plugin
module.exports = {"text-logo":"_2E9TqYXywxFLwkBZMDBCep","textLogo":"_2E9TqYXywxFLwkBZMDBCep"};